import { createStore } from 'vuex'
import cookies from 'js-cookie'
// import emitter from '@/config/emitter.js'

const APP_NAME = import.meta.env.VITE_APP_NAME || 'XETOKO';
const APP_URL = import.meta.env.VITE_APP_URL || 'https://xetup.id';
const TAWK_SRC = import.meta.env.VITE_TAWK_SRC || '';
const BE_URL = import.meta.env.VITE_APP_BACKEND_URL || 'https://xetup.id';

export const store = createStore({
    state() {
        return {
            isLoggedIn: false,
            users: null,
            role: null,
            setting: {
                isDemo: true,
                app_name: APP_NAME,
                app_url: APP_URL,
                tawk_src: TAWK_SRC,
                be_url: BE_URL
            },
            message: {
                visible: false,
                text: null
            },
            token: null,
        }
    },
    mutations: {
        SET_TOKEN(state, token) {
            if (token) {
                state.token = token
            } 
        },
        SET_IS_LOGGEDIN(state, bool) {
            state.isLoggedIn = bool
        },
        SET_USERS(state, users) {
            state.users = users

            if (!users) {
                state.isLoggedIn = false
            } else {
                state.isLoggedIn = true
            }
        },
        SET_SETTING(state, setting) {
            state.setting = { ...state.setting, ...setting };
        },
        SET_ROLE(state, role) {
            state.role = role
        },
        SET_MESSAGE(state, message) {
            if (message) {
                state.message = {...message}
            } else {
                state.message = {
                    visible: false,
                    text: null
                }
            }
        },
    },
    actions: {
        setToken({ commit }, { token, expiresIn }) {
            var expiresTime = new Date(new Date().getTime() + expiresIn * 1000);
           
            cookies.set('x-access-token', token, { expires: expiresTime })
            
            commit('SET_TOKEN', token)
            commit('SET_IS_LOGGEDIN', true)
        },
        setIsLoggedIn({ commit }, bool) {
            commit('SET_IS_LOGGEDIN', bool)
        },
        setUser({ commit }, user) {
            commit('SET_USERS', user)
        },
        setRole({ commit }, role) {
            commit('SET_ROLE', role)
        },
        setUsers({ commit, state }) {
            var token = cookies.get('x-access-token');
            window.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

            window.axios.get('/user').then(({ data: { data: { user } } }) => {
                commit('SET_USERS', user)
                commit('SET_IS_LOGGEDIN', true)
            }).catch((e) => {
                commit('SET_IS_LOGGEDIN', false)
                commit('SET_USERS', null)
            })
        },
        logout({ commit }) {
            window.axios.get('/v1/auth/logout').then(() => {
                // window.localStorage.removeItem('_token')
                cookies.remove('x-access-token')
                commit('SET_MESSAGE', {
                    visible: true,
                    text: 'Successfully logged out'
                })
                
                window.location.reload(true)
            }).catch(({ response }) => {
                console.error(response)
            })
        },
        setMessage({ commit }, message) {
            commit('SET_MESSAGE', message)
        },
        fetchSettings({ commit }) {
            window.axios.get('/setting')
                .then(response => {
                    commit('SET_SETTING', response.data.data.settings);
                })
                .catch(error => {
                    console.error('Failed to fetch settings:', error);
                });
        },
    },
    getters: {
        getToken(state) {
            // var token = window.localStorage.getItem('_token')
            // var token = window.localStorage.getItem('_token')
            // if (!!token) {
            //     return token
            // }
            // return token
            return state.token
        },
        getLoggedIn(state) {
            return state.isLoggedIn
        },
    }
})